import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./userSlice";
import SessionArray from "./SessionArray";
import FormSchema from "./FormSchema";
import sessionId from "./sessionId";
import LastPageSession from "./LastPageSession";
import PageIDSession from "./PageIDSession";
import SchemaIDSession from "./SchemaIDSession";
import userFieldsSlice from "./userFieldsSlice";
import LabelSession from "./LabelSession";
import LabelRefExist from "./LabelRefExist";
import skuSlice from "./skuSlice";
import HeaderQty from "./HeaderQty";
import SchemaObject from "./SchemaObject";
import LabelTypeLogicReducer  from "./LabelTypeLogic";
  
const store = configureStore({
  reducer: {
    user: userSlice.reducer,
    SessionArray: SessionArray.reducer,
    sessionId: sessionId.reducer,
    FormSchema: FormSchema.reducer,
    LastPageSession: LastPageSession.reducer,
    userFields: userFieldsSlice.reducer,
    PageIDSession: PageIDSession.reducer,
    SchemaIDSession: SchemaIDSession.reducer,
    LabelRefExist: LabelRefExist.reducer,
    sku:skuSlice.reducer,
    HeaderQty:HeaderQty.reducer,
    SchemaObject: SchemaObject.reducer,
    LabelSession: LabelSession.reducer,
    LabelTypeLogic : LabelTypeLogicReducer,
  },
});

export default store;
